const routes = [

	

	//---- "Developers" (which includes "Developer Guide", but that's a separate section)
	{ 
		path: '/developers/home', 	//NOTE: 18 July - not currently in the primary nav just because it's not needed. Add it when needed.
		name: "developers-home", 
		component: () => import("/developers/index.vue"),
		meta: { layout: "primary", module: "developers", parentRouteName: "", pageTitle: "Home", breadcrumbLabel: "Developers" }
	},



	// //NOTE: 18 July - not currently in the primary nav just because it's not needed. Add it when needed.
	// { 
	// 	path: '/developers/prototypes/mobile-app', 	
	// 	name: "developers-prototypes-mobile-app", 
	// 	component: () => import("/developers/prototypes/mobile-app.vue"),
	// 	meta: { layout: "no", pageTitle: "Developers > Prototypes > Mobile App" }
	// },
	// { 
	// 	path: '/developers/prototypes/desktop-app',
	// 	name: "developers-prototypes-desktop-app", 
	// 	component: () => import("/developers/prototypes/mobile-app.vue"),
	// 	meta: { layout: "no", pageTitle: "Developers > Prototypes > Desktop App" }
	// },
	// { 
	// 	path: '/developers/prototypes/desktop-app-notifications',
	// 	name: "developers-prototypes-desktop-app-notifications", 
	// 	component: () => import("/developers/prototypes/mobile-app.vue"),
	// 	meta: { layout: "no", pageTitle: "Developers > Prototypes > Desktop App > Notifications" }
	// },






	
	{ 
		path: '/developers/current-activity', 
		name: "developers-current-timesheet-activity",
		component: () => import("/module.timesheets/windows-agent/current-activity.vue"),
		meta: { layout: "primary", module: "timesheets", parentRouteName: "developers-home", pageTitle: "Current Activity" }
	},





	






	//---- "Developer Guide" (previously "Style Guide")
	{ 
		path: '/developers/dev-guide', 
		name: "dev-guide-home", 
		component: () => import("/developers/dev-guide/index.vue"),
		meta: { layout: "primary", module: "developers", parentRouteName: "developers-home", pageTitle: "Developer Guide" }
	},

		//-- Portal/Components
		{ 
			path: '/developers/dev-guide/portal/components/buttons/:component',
			name: "dev-guide-portal-components-buttons", 
			component: () => import("/developers/dev-guide/portal/components/buttons/index.vue"),
			meta: { layout: "primary", module: "developers", parentRouteName: "dev-guide-home", pageTitle: "Buttons" }
		},
		{ 
			path: '/developers/dev-guide/portal/components/forms/:component',
			name: "dev-guide-portal-components-forms", 
			component: () => import("/developers/dev-guide/portal/components/forms/index.vue"),
			meta: { layout: "primary", module: "developers", parentRouteName: "dev-guide-home", pageTitle: "Forms" }
		},
		{ 
			path: '/developers/dev-guide/portal/components/files/:component',
			name: "dev-guide-portal-components-files", 
			component: () => import("/developers/dev-guide/portal/components/files/index.vue"),
			meta: { layout: "primary", module: "developers", parentRouteName: "dev-guide-home", pageTitle: "Files" }
		},
		{ 
			path: '/developers/dev-guide/portal/components/graphics/:component',
			name: "dev-guide-portal-components-graphics", 
			component: () => import("/developers/dev-guide/portal/components/graphics/index.vue"),
			meta: { layout: "primary", module: "developers", parentRouteName: "dev-guide-home", pageTitle: "Graphics" }
		},
		{ 
			path: '/developers/dev-guide/portal/components/layout/:component',
			name: "dev-guide-portal-components-layout", 
			component: () => import("/developers/dev-guide/portal/components/layout/index.vue"),
			meta: { layout: "primary", module: "developers", parentRouteName: "dev-guide-home", pageTitle: "Layout" }
		},
		{ 
			path: '/developers/dev-guide/portal/components/other/:component',
			name: "dev-guide-portal-components-other", 
			component: () => import("/developers/dev-guide/portal/components/other/index.vue"),
			meta: { layout: "primary", module: "developers", parentRouteName: "dev-guide-home", pageTitle: "Other" }
		},
		{ 
			path: '/developers/dev-guide/portal/components/tables/:component',
			name: "dev-guide-portal-components-tables", 
			component: () => import("/developers/dev-guide/portal/components/tables/index.vue"),
			meta: { layout: "primary", module: "developers", parentRouteName: "dev-guide-home", pageTitle: "Tables" }
		},
		{ 
			path: '/developers/dev-guide/portal/components/tabs/:component',
			name: "dev-guide-portal-components-tabs", 
			component: () => import("/developers/dev-guide/portal/components/tabs/index.vue"),
			meta: { layout: "primary", module: "developers", parentRouteName: "dev-guide-home", pageTitle: "Tabs" }
		},
		{ 
			path: '/developers/dev-guide/portal/components/typography/:component',
			name: "dev-guide-portal-components-typography", 
			component: () => import("/developers/dev-guide/portal/components/typography/index.vue"),
			meta: { layout: "primary", module: "developers", parentRouteName: "dev-guide-home", pageTitle: "Typography" }
		},
		{ 
			path: '/developers/dev-guide/portal/components/timesheets/:component',
			name: "dev-guide-portal-components-timesheets", 
			component: () => import("/developers/dev-guide/portal/components/timesheets/index.vue"),
			meta: { layout: "primary", module: "developers", parentRouteName: "dev-guide-home", pageTitle: "Timesheets" }
		},


		{ 
			path: '/developers/dev-guide/portal/helpers/:helper',
			name: "dev-guide-portal-helpers", 
			component: () => import("/developers/dev-guide/portal/helpers/index.vue"),
			meta: { layout: "primary", module: "developers", parentRouteName: "dev-guide-home", pageTitle: "Helpers" }
		},



	{ 
		path: '/developers/dev-guide/test-calendar', 
		name: "dev-guide-test-calendar", 
		component: () => import("/developers/dev-guide/test-calendar.vue"),
		meta: { layout: "primary", module: "developers", parentRouteName: "dev-guide-home", pageTitle: "Test Calendar" }
	},
	{ 
		path: '/developers/dev-guide/test-calendar/:timesheetId', 
		name: "dev-guide-test-calendar-with-timesheet", 
		component: () => import("/developers/dev-guide/test-calendar.vue"),
		meta: { layout: "primary", module: "developers", parentRouteName: "dev-guide-home", pageTitle: "Test Calendar" }
	},
	{ 
		path: '/developers/dev-guide/test-keyword-extraction', 
		name: "dev-guide-test-keyword-extraction", 
		component: () => import("/developers/dev-guide/test-keyword-extraction.vue"),
		meta: { layout: "primary", module: "developers", parentRouteName: "dev-guide-home", pageTitle: "Test Keyword Extraction" }
	},








	//---- Code snippets library (copy-and-paste starting points for shared patterns).
	//	   Topics are data - see /developers/snippets/snippet-topics.js. Adding one
	//	   needs no route change.
	{
		path: '/developers/snippets',
		name: "dev-snippets-index",
		component: () => import("/developers/snippets/index.vue"),
		meta: { layout: "primary", module: "developers", parentRouteName: "", pageTitle: "Code Snippets" }
	},
	{
		path: '/developers/snippets/:topic',
		name: "dev-snippets-topic",
		component: () => import("/developers/snippets/topic.vue"),
		// The page fills {snippetTopic} from the topic it resolved - see topic.vue.
		meta: { layout: "primary", module: "developers", parentRouteName: "dev-snippets-index", pageTitle: "Code Snippets > {snippetTopic}" }
	},




	//---- API info: which build each environment's back-end API is running. Lotus developers only.
	//	   Moved here from /system-admin/api-info, which now redirects (see routes.system-admin.js).
	{
		path: '/developers/api-info',
		name: "developers-api-info",
		component: () => import("/developers/api-info/api-info.vue"),
		meta: { layout: "primary", module: "developers", parentRouteName: "", pageTitle: "API Info" }
	},




	//---- Stored files in any account: list, upload, view/download and (soft) delete. Lotus developers only.
	//	   Exercises every /Files/** endpoint plus /Shared/Files/GetFileByID/v1.
	{
		path: '/developers/files',
		name: "developers-files",
		component: () => import("/developers/files/index.vue"),
		meta: { layout: "primary", module: "developers", parentRouteName: "", pageTitle: "Files" }
	},




	//---- Configuration values (view/edit raw `Configuration` records). Lotus developers only.
	//	   Types, sections and keys are all reflected from the back end's `Keys` classes, so a
	//	   newly-added configuration value needs no change here or on the page.
	{
		path: '/developers/configuration',
		name: "dev-configuration",
		component: () => import("/developers/configuration/index.vue"),
		meta: { layout: "primary", module: "developers", parentRouteName: "", pageTitle: "Configuration Values" }
	},




	{
		path: '/developers/showcase',
		name: "dev-showcase",
		component: () => import("/developers/showcase/index.vue"),
		meta: { layout: "primary", module: "developers", parentRouteName: "", pageTitle: "New Design System Showcase" }
	},

	{ 
		path: '/developers/showcase/:page', 
		name: "dev-showcase-page",
		component: () => import("/developers/showcase/index.vue"),
		meta: { layout: "primary", module: "developers", parentRouteName: "", pageTitle: "New Design System Showcase" }
	},





	



	
	//---- Debugger
	{ 
		path: '/debugger/mobile/location-with-comments', 
		name: "DebuggerMobileLocationWithComments",
		component: () => import("/developers/debugger/mobile-location-with-comments.vue"),
		meta: { layout: "primary", module: "developers", parentRouteName: "", pageTitle: "Location With Comments", kbFile: "", kbTitle: "" } 
	},

	// The page fills {logType} with the log type it is showing, and leaves it unset on the overview
	// (an unresolved placeholder is dropped along with its separator, so the title degrades to
	// "Debugger > Logs"). See developers/debugger/debug-logs.vue.
	{
		path: '/debugger/debug-logs',
		name: "debugger-debug-logs",
		component: () => import("/developers/debugger/debug-logs.vue"),
		meta: { layout: "primary", module: "developers", parentRouteName: "", pageTitle: "Debugger > Logs > {logType}", kbFile: "", kbTitle: "" }
	},
	
	// The EmailSendLogs table - one row per email the platform tried to send. Not under /debugger
	// with the diagnostic log viewers: it reads a table of the primary database and answers "did
	// this person get their email, and which environment sent it?" rather than "what went wrong".
	{
		path: '/developers/email-send-logs',
		name: "developers-email-send-logs",
		component: () => import("/developers/email-send-logs/index.vue"),
		meta: { layout: "primary", module: "developers", parentRouteName: "", pageTitle: "Email Send Logs", kbFile: "", kbTitle: "" }
	},

	{
		path: '/monitoring/logs',
		name: "monitoring-logs",
		component: () => import("/developers/debugger/monitoring-logs.vue"),
		meta: { layout: "primary", module: "developers", parentRouteName: "", pageTitle: "Monitoring Logs", kbFile: "", kbTitle: "" } 
	},



]


export default routes;